import { useLocation } from 'react-router-dom';

/** Use this to get params from the queries
  *
  * - URLSearchParams: https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
  * - Example from React Router: https://reactrouter.com/web/example/query-parameters */
export default () => new URLSearchParams(useLocation().search);
